<div class="page-body">
    <h1>Документы</h1>
    <h2>Специальная оценка условий труда</h2>
    <a href="assets/documents/2021.pdf" download="">2021</a>
    <a href="assets/documents/2022.pdf" download>2022</a>
    <a href="assets/documents/2023.pdf" download>2023</a>
    <a href="assets/documents/2024.pdf" download>2024</a>
    <a href="assets/documents/2025.pdf" download>2025</a>
</div>
